/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/CameraConfiguration.yaml
/** @hidden */
export const CameraModuleValues = ['FRONT', 'BACK', 'BACK_WIDEST'];
/** @hidden */
export const CameraPreviewAspectRatioValues = ['RATIO_4_3', 'RATIO_16_9'];
/**
Configuration of the camera settings to be used while scanning.
*/
export class CameraConfiguration {
    /** @param source {@displayType `DeepPartial<CameraConfiguration>`} */
    constructor(source = {}) {
        /**
          Determines which camera module to use on start-up.
          
          Default is BACK
          */
        this.cameraModule = 'BACK';
        /**
          The zoom steps available to the user.
          */
        this.zoomSteps = [1.0, 2.0, 5.0];
        /**
          The default zoom factor on start-up.
          
          Default is 1.0
          */
        this.defaultZoomFactor = 1.0;
        /**
          Determines whether the flash is enabled on start-up.
          
          Default is false
          */
        this.flashEnabled = false;
        /**
          Determines whether to lock the focus at the minimum possible distance (device-specific).
          
          Default is false
          */
        this.minFocusDistanceLock = false;
        /**
          Determines whether touch-to-focus is enabled or not.
          
          Default is false
          */
        this.touchToFocusEnabled = false;
        /**
          Determines whether pinch-to-zoom is enabled or not.
          
          Default is true
          */
        this.pinchToZoomEnabled = true;
        /**
          Determines which mode to use when orientation should be locked to landscape or portrait.
          
          Default is NONE
          */
        this.orientationLockMode = 'NONE';
        /**
          Determines which camera preview mode to use.
          
          Default is FILL_IN
          */
        this.cameraPreviewMode = 'FILL_IN';
        /**
          Tries to select the camera preview aspect ratio that best matches the given aspect ratio. If no exact match is found, it selects the closest one available. Android only.
          */
        this.cameraPreviewAspectRatio = null;
        /**
          When enabled it allows zooming using camera control button (iPhone 16 series). iOS only.
          
          Default is true
          */
        this.hardwareButtonsEnabled = true;
        /**
          The rate of detections/recognitions per second in normal performance mode. If the number is equal or greater than the video frame rate, no frames will be skipped.
          
          Default is 20
          */
        this.fpsLimit = 20;
        /**
          The size of the image from camera which would be sent to the scanner for live scanning.
          
          Default is FULL_HD
          */
        this.cameraLiveScannerResolution = 'FULL_HD';
        if (source.cameraModule !== undefined) {
            this.cameraModule = source.cameraModule;
        }
        if (source.zoomSteps !== undefined) {
            this.zoomSteps = source.zoomSteps.map((it) => {
                return it;
            });
        }
        if (source.defaultZoomFactor !== undefined) {
            this.defaultZoomFactor = source.defaultZoomFactor;
        }
        if (source.flashEnabled !== undefined) {
            this.flashEnabled = source.flashEnabled;
        }
        if (source.minFocusDistanceLock !== undefined) {
            this.minFocusDistanceLock = source.minFocusDistanceLock;
        }
        if (source.touchToFocusEnabled !== undefined) {
            this.touchToFocusEnabled = source.touchToFocusEnabled;
        }
        if (source.pinchToZoomEnabled !== undefined) {
            this.pinchToZoomEnabled = source.pinchToZoomEnabled;
        }
        if (source.orientationLockMode !== undefined) {
            this.orientationLockMode = source.orientationLockMode;
        }
        if (source.cameraPreviewMode !== undefined) {
            this.cameraPreviewMode = source.cameraPreviewMode;
        }
        if (source.cameraPreviewAspectRatio !== undefined) {
            this.cameraPreviewAspectRatio =
                source.cameraPreviewAspectRatio != null
                    ? CameraPreviewAspectRatioValues.includes(source.cameraPreviewAspectRatio)
                        ? source.cameraPreviewAspectRatio
                        : null
                    : null;
        }
        if (source.hardwareButtonsEnabled !== undefined) {
            this.hardwareButtonsEnabled = source.hardwareButtonsEnabled;
        }
        if (source.fpsLimit !== undefined) {
            this.fpsLimit = source.fpsLimit;
        }
        if (source.cameraLiveScannerResolution !== undefined) {
            this.cameraLiveScannerResolution = source.cameraLiveScannerResolution;
        }
    }
}
//# sourceMappingURL=CameraConfiguration.js.map